module.exports = __webpack_public_path__ + "img/Gobiernos.dcaf2bd7.svg";